import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';

export const templateEasmScanConfigurationAssetGrid = document.createElement('template');

templateEasmScanConfigurationAssetGrid.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="content">
      <div class="grid">
        <gz-grid-view class="grid-view" hideGridRefresh disableGridSettings></gz-grid-view>
      </div>
    </div>
  </div>
`;
